import { createAsyncThunk } from '@reduxjs/toolkit';
import { MarketApi } from '../../api/MarketApi';
import { DataMaintenanceApi } from '../../api/DataMaintenanceApi';

//Market Thunks

//To get all markets for Price list map create and update
export const getCountryList = createAsyncThunk(
  'market/getCountryList',
  async (_action, thunkAPI) => {
    return DataMaintenanceApi.getCountryList(thunkAPI.dispatch);
  }
);

//To get paginated market details
export const getMarkets = createAsyncThunk(
  'market/getMarkets',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return MarketApi.getMarkets(action, thunkAPI.dispatch);
  }
);

//To get a market details
export const getMarketDetails = createAsyncThunk(
  'market/getMarketDetails',
  async (action: { request: string[] }, thunkAPI) => {
    return MarketApi.getMarketDetails(action, thunkAPI.dispatch);
  }
);

//To update a market
export const updateMarket = createAsyncThunk(
  'market/updateMarket',
  async (action: { request }, thunkAPI) => {
    return MarketApi.updateMarket(action, thunkAPI.dispatch);
  }
);

//To create a market
export const createMarket = createAsyncThunk(
  'market/createMarket',
  async (action: { request }, thunkAPI) => {
    return MarketApi.createMarket(action, thunkAPI.dispatch);
  }
);

//To delete market(s)
export const deleteMarket = createAsyncThunk(
  'market/deleteMarket',
  async (action: { request }, thunkAPI) => {
    return MarketApi.deleteMarket(action, thunkAPI.dispatch);
  }
);

//Market Association Thunks
//To get paginated market association data
export const getMarketAssociation = createAsyncThunk(
  'market/getMarketAssociation',
  async (
    action: { page: number; limit: number; searchCode?: string; productId?: string },
    thunkAPI
  ) => {
    action.productId = action.searchCode;
    return MarketApi.getMarketAssociation(action, thunkAPI.dispatch);
  }
);

//To update market association data
export const updateMarketAssociation = createAsyncThunk(
  'market/updateMarketAssociation',
  async (action: { request }, thunkAPI) => {
    return MarketApi.updateMarketAssociation(action, thunkAPI.dispatch);
  }
);

//To delete market association data
export const deleteMarketAssociation = createAsyncThunk(
  'market/deleteMarketAssociation',
  async (action: { request }, thunkAPI) => {
    return MarketApi.deleteMarketAssociation(action, thunkAPI.dispatch);
  }
);
